import React from 'react'

import { Chip, ChipProps } from '@mui/material'

import colors from '@/design-system/themes/colors.json'
import { useDesktopMediaQuery } from '@/utils'

/**
 * MUI chip component with custom vivid seats styling
 * @returns
 */
const StyledChip = (props: ChipProps) => {
    const isDesktop = useDesktopMediaQuery()

    return (
        <Chip
            {...props}
            sx={{
                borderColor: colors.teal[600],
                '&.MuiChip-filled': {
                    color: colors.teal[800],
                    border: `1px solid ${colors.teal[400]}`,
                    backgroundColor: colors.teal[100],
                },
                '&.MuiChip-outlined': isDesktop
                    ? {}
                    : {
                          // Mui has a problem where deselecting a chip on mobile
                          // leaves the hover state on, which makes the background grey
                          // until you click outside of it. Since we can't hover on
                          // touchscreen, we can just break that style
                          '&&:hover': {
                              backgroundColor: 'transparent',
                          },
                          '&&:focus': {
                              backgroundColor: 'transparent',
                          },
                      },
                ...props.sx,
            }}
        />
    )
}

export default StyledChip
